
import { Options, setup, Vue } from "vue-class-component";
import { computed, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faEye,
  faStar,
  faBell,
  faPhone,
  faCaretDown,
  faCaretUp,
  faCaretRight
} from "@fortawesome/free-solid-svg-icons";
import { useMeta } from "vue-meta";

library.add( faEye, faStar, faBell, faPhone, faCaretDown, faCaretUp, faCaretRight );

import { Bar, Doughnut } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, BarElement, CategoryScale, LinearScale } from "chart.js";

ChartJS.register( Title, Tooltip, ArcElement, Legend, BarElement, CategoryScale, LinearScale );

@Options( {
  props : {
    tarif : Boolean
  },
  components : {
    SearchOld : defineAsyncComponent( () => import("./SearchOld.vue" ) ),
    SearchNew : defineAsyncComponent( () => import("./SearchNew.vue" ) )
  }
} )
export default class extends Vue
{
  store     = useStore( key );
  map_shown = false;
  window    = window;
  template  = null;

  mounted()
  {
    let headers = new Headers();

    const city     = typeof this.$route.params.city !== "undefined" ? this.$route.params.city : "Paris";
    const postcode = typeof this.$route.params.postcode !== "undefined" ? this.$route.params.postcode : "75000";

    fetch( this.store.state.apiVue + "searchTemplate/" + city + "/" + postcode, {
      method  : "GET",
      headers : headers,
      cache   : "no-cache"
    } ).then( ( res ) => {
      return res.json();
    } ).then( ( json ) => {
      if( typeof json.error !== "undefined" )
        this.store.state.error = "Une erreur est survenue lors du chargement de la page (Error " + json.error + ")";
      else
        this.template = json.data;
    } ).catch( error => {
      this.store.state.loading = false;
      console.error( error );
    } );
  }
}
